import React from 'react'

// material ui
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'

// components
import Typography from '@mui/material/Typography'

// styles
import { styled } from '@mui/material/styles'
import { compose, spacing, sizing, positions } from '@mui/system'

const StyledFormControl = styled(FormControl)(
  compose(spacing, sizing, positions)
)

const SEVERITY_OPTIONS = [
  {
    label: 'No',
    value: 'null'
  },
  {
    label: 'Moderate',
    value: 'false'
  },
  {
    label: 'Severe',
    value: 'true'
  }
]

const SelectStandardAllergies = props => {
  const { food, allergies, form, onChangeStandardAllergyField } = props

  // return the selected severity for the given allergy as a string, i.e "true",
  // "false", or "null"
  const severityValueFor = allergyName => {
    const camperAllergy = (form.camperAllergies || []).find(
      allergy => !allergy.custom && allergy.name === allergyName
    )
    if (camperAllergy) {
      return String(camperAllergy.severe)
    }

    return 'null'
  }

  // display moderate/severe allergy selections in bold
  const severityFontWeight = value =>
    value === 'null' ? 'fontWeightRegular' : 'fontWeightBold'

  return (
    <Grid container spacing={1}>
      {allergies
        .filter(a => !a.custom && (food ? a.food : !a.food))
        .map(allergy => (
          <Grid item xs={6} sm={4} key={allergy.id}>
            <StyledFormControl variant='standard' minWidth={100}>
              <InputLabel id={`select-${allergy.id}-allergy-label`}>
                {allergy.name}
              </InputLabel>
              <Select
                id={`select-${allergy.id}-allergy`}
                value={severityValueFor(allergy.name)}
                onChange={onChangeStandardAllergyField({
                  name: allergy.name,
                  food: allergy.food
                })}
              >
                {SEVERITY_OPTIONS.map(({ label, value }) => (
                  <MenuItem key={value} value={value}>
                    <Typography fontWeight={severityFontWeight(value)}>
                      {label}
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
            </StyledFormControl>
          </Grid>
        ))}
    </Grid>
  )
}

export default SelectStandardAllergies
